import { ReactNode } from 'react';
import { Box } from '@mui/material';
import { useListPagePaper } from '../ListPagePaper';

interface IResponseDataHandleProps {
  isLoading: boolean;
  isError: boolean;
  loadingComponent: ReactNode;
  errorComponent: ReactNode;
  totalItems: number | undefined;
  emptyComponent: ReactNode;
  children: ReactNode;
  fillAvailableHeight?: boolean;
}

export function ResponseDataHandle({
  isLoading,
  isError,
  loadingComponent,
  errorComponent,
  totalItems,
  emptyComponent,
  children,
  fillAvailableHeight = false,
}: IResponseDataHandleProps) {
  const isInsideListPagePaper = useListPagePaper();
  const shouldFillAvailableHeight =
    fillAvailableHeight || isInsideListPagePaper;

  const renderContent = (content: ReactNode) => {
    if (!shouldFillAvailableHeight) {
      return <>{content}</>;
    }

    return (
      <Box sx={{ display: 'flex', flex: 1, minHeight: 0, width: '100%' }}>
        {content}
      </Box>
    );
  };

  const renderCenteredState = (content: ReactNode) => {
    if (!shouldFillAvailableHeight) {
      return <>{content}</>;
    }

    return (
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flex: 1,
          justifyContent: 'center',
          minHeight: 0,
          width: '100%',
        }}
      >
        {content}
      </Box>
    );
  };

  if (isLoading) {
    return renderContent(loadingComponent);
  }

  if (isError) {
    return renderCenteredState(errorComponent);
  }

  if (!totalItems) {
    return renderCenteredState(emptyComponent);
  }

  return renderContent(children);
}
